import { Create } from "react-admin";
import { WayOfArrivalForm } from "./form";

export const WayOfArrivalCreate = () => (
  <Create title="Create Way of Arrival" redirect="list">
    <WayOfArrivalForm />
  </Create>
);
